export default __webpack_public_path__ + "static/media/onepercent.347f66a4.jpg";